import React, { useEffect, useRef, useState } from "react";
import { Empty, Tabs, Steps } from "antd";
import Box from "@mui/material/Box";
import { Button, Checkbox, Form, Input, Select } from "antd";
import {
  FileWordOutlined,
  FileDoneOutlined,
  SolutionOutlined,
  CheckCircleFilled,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import MainHeader from "../MainHeader/MainHeader";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
} from "react-router-dom";
import Tabss from "./Tabs";
import { CKEditor } from "ckeditor4-react";
import { toast } from "react-toastify";
import { Alert } from "antd";
import TextEditor from "../TextEditor";
import "../AddForm1/form.scss";

const { Step } = Steps;
const { TabPane } = Tabs;
const { TextArea } = Input;

function Instruction({ t }) {
  const editorRef = useRef(null);

  const lan = useSelector((state) => state.langReducer);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [data, setDatas] = useState();
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const [editable, setEditable] = useState(false);
  const [error, setError] = useState();
  const [eng, setEng] = useState("");
  const [rus, setRus] = useState("");
  const [uzb, setUzb] = useState("");
  const [general, setgeneral] = useState({ uz: "", ru: "", en: "" });
  const [pharmacological, setpharmacological] = useState({
    uz: "",
    ru: "",
    en: "",
  });
  const [usage, setusage] = useState({ uz: "", ru: "", en: "" });
  const [prevention, setprevention] = useState({ uz: "", ru: "", en: "" });

  useEffect(() => {
    axios
      .get(url.url + `/application/${searchParams.get("id")}`, {
        headers: headers(),
      })
      .then((res) => {
        setDatas(res.data.data);
        setgeneral(res.data.data.drug.instruction?.general);
        setpharmacological(res.data.data.drug.instruction?.pharmacological);
        setusage(res.data.data.drug.instruction?.usage);
        setprevention(res.data.data.drug.instruction?.prevention);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
      });
  }, []);
  const handleSave = () => {
    const datatext = {
      general: general,
      pharmacological: pharmacological,
      usage: usage,
      prevention: prevention,
    };
    axios
      .put(url.url + `/drug/${data?.drug.id}/instruction`, datatext, {
        headers: headers(),
      })
      .then((res) => {
        if (res.status == 200) {
          setError();
          navigate({
            pathname: "/account/applications/document",
            search: `?${createSearchParams({
              id: searchParams.get("id"),
              con_id: searchParams.get("con_id"),
            })}`,
          });
          toast.success(t("Success!"));
        }
      })
      .catch((err) => {
        setError(err.response.data.errors);
      });
  };
  console.log("general", general);
  const langs = { 1: "uz", 2: "ru", 3: "en" };
  const langTabs = [
    ["1", "UZ", t("Uzbek")],
    ["2", "RU", t("Russian")],
    ["3", "EN", t("English")],
  ];
  const fields = [
    { name: "general", value: general, set: setgeneral },
    { name: "pharmacological", value: pharmacological, set: setpharmacological },
    { name: "usage", value: usage, set: setusage },
    { name: "prevention", value: prevention, set: setprevention },
  ];
  const isFilled = (html) =>
    !!String(html ?? "")
      .replace(/<[^>]*>|&nbsp;/g, "")
      .trim();
  const totalFilled = fields.reduce(
    (sum, f) =>
      sum + Object.values(langs).filter((l) => isFilled(f.value?.[l])).length,
    0
  );
  const totalCount = fields.length * Object.keys(langs).length;
  const [active, setActive] = useState(0);
  const [keys, setKeys] = useState("1");

  const changeTab = (activeKey) => {
    setKeys(activeKey);
  };
  useEffect(() => {
    axios
      .get(url.url + `/application/${searchParams.get("id")}`, {
        headers: headers(),
      })
      .then((res) => {
        if (res.data.data.editable == 1) setEditable(true);
      });
  }, [lan]);

  return (
    <div>
      <MainHeader title={t("Edit application")} />

      <div className="add-application">
        <Box sx={{ width: "100%" }}>
          <Steps>
            <Step
              status="finish"
              title={t("Application")}
              icon={<SolutionOutlined />}
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (searchParams.get("con_id"))
                  navigate({
                    pathname: "/account/applications/edit",
                    search: `?${createSearchParams({
                      id: searchParams.get("id"),
                      con_id: searchParams.get("con_id"),
                    })}`,
                  });
                else
                  navigate({
                    pathname: "/account/applications/edit",
                    search: `?${createSearchParams({
                      id: searchParams.get("id"),
                    })}`,
                  });
              }}
            />
            <Step
              status="process"
              title={t("Instruction")}
              icon={<FileDoneOutlined />}
            />
            <Step
              status="wait"
              title={t("Document")}
              style={{ cursor: "pointer" }}
              icon={<FileWordOutlined />}
              onClick={() => {
                if (!editable) {
                  if (searchParams.get("con_id"))
                    navigate({
                      pathname: "/account/applications/documenteditable",
                      search: `?${createSearchParams({
                        id: searchParams.get("id"),
                        con_id: searchParams.get("con_id"),
                      })}`,
                    });
                  else
                    navigate({
                      pathname: "/account/applications/documenteditable",
                      search: `?${createSearchParams({
                        id: searchParams.get("id"),
                      })}`,
                    });
                } else {
                  if (searchParams.get("con_id"))
                    navigate({
                      pathname: "/account/applications/document",
                      search: `?${createSearchParams({
                        id: searchParams.get("id"),
                        con_id: searchParams.get("con_id"),
                      })}`,
                    });
                  else
                    navigate({
                      pathname: "/account/applications/document",
                      search: `?${createSearchParams({
                        id: searchParams.get("id"),
                      })}`,
                    });
                }
              }}
            />
          </Steps>
        </Box>
      </div>
      <section className="af-card ins-card">
        <div className="af-card__head">
          <div className="af-card__title">
            <span className="af-card__num">
              <FileDoneOutlined />
            </span>
            <h5>{t("Instruction")}</h5>
          </div>
          <div className="ins-progress">
            <div className="ins-progress__bar">
              <span
                style={{ width: `${(totalFilled / totalCount) * 100}%` }}
              />
            </div>
            <b>
              {totalFilled}/{totalCount}
            </b>
          </div>
        </div>

        <div className="ins-layout">
          <nav className="ins-nav">
            {fields.map((f, i) => (
              <button
                type="button"
                key={f.name}
                className={
                  active === i ? "ins-nav__item ins-nav__item--active" : "ins-nav__item"
                }
                onClick={() => setActive(i)}
              >
                <span className="ins-nav__num">{i + 1}</span>
                <span className="ins-nav__text">
                  <span className="ins-nav__name">{t(f.name)}</span>
                  <span className="ins-nav__langs">
                    {langTabs.map(([k, short]) => (
                      <span
                        key={k}
                        className={
                          isFilled(f.value?.[langs[k]])
                            ? "ins-chip ins-chip--done"
                            : "ins-chip"
                        }
                      >
                        {short}
                      </span>
                    ))}
                  </span>
                </span>
              </button>
            ))}
          </nav>

          <div className="ins-editor">
            <div className="ins-editor__head">
              <h6>
                {active + 1}. {t(fields[active].name)}
              </h6>
              <div className="ins-langs">
                {langTabs.map(([k, short, label]) => (
                  <button
                    type="button"
                    key={k}
                    title={label}
                    className={keys === k ? "ins-lang ins-lang--active" : "ins-lang"}
                    onClick={() => changeTab(k)}
                  >
                    {short}
                    {isFilled(fields[active].value?.[langs[k]]) ? (
                      <CheckCircleFilled className="ins-lang__done" />
                    ) : (
                      <ExclamationCircleFilled className="ins-lang__todo" />
                    )}
                  </button>
                ))}
              </div>
            </div>

            <TextEditor
              key={`${keys}${active + 1}`}
              id={langs[keys]}
              onChange={(value) =>
                fields[active].set((prev) => ({ ...prev, [langs[keys]]: value }))
              }
              value={fields[active].value?.[langs[keys]]}
            />

            <div className="ins-editor__nav">
              <Button
                disabled={active === 0}
                onClick={() => setActive(active - 1)}
              >
                ← {t(fields[Math.max(active - 1, 0)].name)}
              </Button>
              <Button
                disabled={active === fields.length - 1}
                onClick={() => setActive(active + 1)}
              >
                {t(fields[Math.min(active + 1, fields.length - 1)].name)} →
              </Button>
            </div>
          </div>
        </div>
      </section>

      <div className="af-actions">
        <div className="af-actions__date">
          <FileDoneOutlined />
          <span>{t("Instruction")}</span>
        </div>
        <div className="af-actions__buttons">
          {editable ? (
            <>
              <Button
                size="large"
                onClick={() => navigate("/account/applications")}
              >
                {t("Cancel")}
              </Button>
              <Button type="primary" size="large" onClick={handleSave}>
                {t("Save")}
              </Button>
            </>
          ) : (
            <>
              <Button size="large" onClick={() => navigate(-1)}>
                {t("Back")}
              </Button>
              <Button
                type="primary"
                size="large"
                onClick={() =>
                  navigate({
                    pathname: "/account/applications/documenteditable",
                    search: `?${createSearchParams({
                      id: searchParams.get("id"),
                      con_id: searchParams.get("con_id"),
                    })}`,
                  })
                }
              >
                {t("Next")}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
export default withTranslation()(Instruction);
